import React, {type PropsWithChildren, type ReactElement, createContext, useContext} from 'react'

type ConfigContextValue = {
  /**
   * @deprecated Не используется, будет удалено
   *  */
  trustDomain?: string
  /**
   * @deprecated Не используется, будет удалено
   *  */
  clientId?: string
  lang: string
  currency?: string
  /**
   * @deprecated Не используется, будет удалено
   *  */
  device?: 'desktop' | 'mobile'
  /**
   * @deprecated Не используется, будет удалено
   *  */
  country?: string
  /**
   * @deprecated Не используется, будет удалено
   *  */
  makeUrl?: (url: string) => string
}

type Props = PropsWithChildren<ConfigContextValue>

const Context = createContext<ConfigContextValue | null>(null)

export function useConfigContext() {
  const context = useContext(Context)

  if (context === null) {
    throw new Error('useConfigContext must be used within a ConfigProvider')
  }

  return context
}

export function BoundCardConfigContext({children, ...config}: Props): ReactElement<Props> {
  return <Context.Provider value={config}>{children}</Context.Provider>
}
